









































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import store from '@/store/store';
import Auth from '@/store/modules/auth';
import { db } from '@/plugins/firebase';
import { levelTable } from '@/plugins/levelTable';
const authModule = getModule(Auth, store);

@Component({})
export default class Profile extends Vue {
  get expForNextLevel() {
    return levelTable[this.user.level];
  }

  get levelProgress(): number {
    const prev = levelTable[this.user.level - 1] || 0;
    const next = levelTable[this.user.level];
    const current = this.user.exp;
    //console.log(prev, next, current);
    return ((current - prev) / (next - prev)) * 100;
  }

  get user() {
    return authModule.user;
  }
}
